import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { RouteWithSubRoutes, NotFound } from '@cordata/buffet';

import InsuranceCarriersIndex from './collection';

const InsuranceCarriers = ({ routes }) => {
  const { url, path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route
          exact
          path={url}
          render={() => <InsuranceCarriersIndex />}
        />

        {routes.map(r => (
          <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
        ))}

        <Route path="*"><NotFound isRoute /></Route>
      </Switch>
    </>
  );
};

export default InsuranceCarriers;
